import React from 'react';
import './HeroSectionLanding.css';
import { useNavigate } from 'react-router-dom';

const HeroSectionLanding = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-landing">
      
      {/* VIDEO DE FONDO */}
      <video
        className="hero-landing__video"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="https://res.cloudinary.com/dsvywoswv/video/upload/f_auto,q_auto/hero-background_-_Compressed_with_FlexClip_cytkso.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* OVERLAY */}
      <div className="hero-landing__overlay"></div>

      {/* CONTENIDO */}
      <div className="hero-landing__content">
        <h1 className="hero-landing__headline">
          Maximize Your Returns
        </h1>

        <h2 className="hero-landing__subheadline">
          The Data Behind Australia’s Best Property Markets
        </h2>

        <p className="hero-landing__description">
          Decode the economic signals behind market cycles and uncover where growth and rental yields align.
        </p>

        <div className="hero-landing__actions">
          <button
            className="hero-landing__btn hero-landing__btn--yellow"
            onClick={() => navigate('/signup')}
          >
            Start Free Trial
          </button>

        </div>
      </div>
    </section>
  );
};

export default HeroSectionLanding;
